module.exports = __webpack_public_path__ + "img/B09273_7A573D_C7AF97_84644C-256px.ebd973ae.png";